/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TransactionsIndexRouteImport } from './routes/transactions/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as SavingsIndexRouteImport } from './routes/savings/index'
import { Route as PlanIndexRouteImport } from './routes/plan/index'
import { Route as OpenBankingIndexRouteImport } from './routes/open-banking/index'
import { Route as LoansIndexRouteImport } from './routes/loans/index'
import { Route as InsightsIndexRouteImport } from './routes/insights/index'
import { Route as InboxIndexRouteImport } from './routes/inbox/index'
import { Route as ImportIndexRouteImport } from './routes/import/index'
import { Route as HouseholdIndexRouteImport } from './routes/household/index'
import { Route as BudgetIndexRouteImport } from './routes/budget/index'
import { Route as BillsIndexRouteImport } from './routes/bills/index'
import { Route as ActivityIndexRouteImport } from './routes/activity/index'
import { Route as OpenBankingCallbackRouteImport } from './routes/open-banking/callback'
import { Route as HouseholdInviteRouteImport } from './routes/household/invite'
import { Route as HouseholdCreateRouteImport } from './routes/household/create'
import { Route as ConnectTokenRouteImport } from './routes/connect/$token'
import { Route as BillsHistoryRouteImport } from './routes/bills/history'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TransactionsIndexRoute = TransactionsIndexRouteImport.update({
  id: '/transactions/',
  path: '/transactions/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const SavingsIndexRoute = SavingsIndexRouteImport.update({
  id: '/savings/',
  path: '/savings/',
  getParentRoute: () => rootRouteImport,
} as any)
const PlanIndexRoute = PlanIndexRouteImport.update({
  id: '/plan/',
  path: '/plan/',
  getParentRoute: () => rootRouteImport,
} as any)
const OpenBankingIndexRoute = OpenBankingIndexRouteImport.update({
  id: '/open-banking/',
  path: '/open-banking/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoansIndexRoute = LoansIndexRouteImport.update({
  id: '/loans/',
  path: '/loans/',
  getParentRoute: () => rootRouteImport,
} as any)
const InsightsIndexRoute = InsightsIndexRouteImport.update({
  id: '/insights/',
  path: '/insights/',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxIndexRoute = InboxIndexRouteImport.update({
  id: '/inbox/',
  path: '/inbox/',
  getParentRoute: () => rootRouteImport,
} as any)
const ImportIndexRoute = ImportIndexRouteImport.update({
  id: '/import/',
  path: '/import/',
  getParentRoute: () => rootRouteImport,
} as any)
const HouseholdIndexRoute = HouseholdIndexRouteImport.update({
  id: '/household/',
  path: '/household/',
  getParentRoute: () => rootRouteImport,
} as any)
const BudgetIndexRoute = BudgetIndexRouteImport.update({
  id: '/budget/',
  path: '/budget/',
  getParentRoute: () => rootRouteImport,
} as any)
const BillsIndexRoute = BillsIndexRouteImport.update({
  id: '/bills/',
  path: '/bills/',
  getParentRoute: () => rootRouteImport,
} as any)
const ActivityIndexRoute = ActivityIndexRouteImport.update({
  id: '/activity/',
  path: '/activity/',
  getParentRoute: () => rootRouteImport,
} as any)
const OpenBankingCallbackRoute = OpenBankingCallbackRouteImport.update({
  id: '/open-banking/callback',
  path: '/open-banking/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const HouseholdInviteRoute = HouseholdInviteRouteImport.update({
  id: '/household/invite',
  path: '/household/invite',
  getParentRoute: () => rootRouteImport,
} as any)
const HouseholdCreateRoute = HouseholdCreateRouteImport.update({
  id: '/household/create',
  path: '/household/create',
  getParentRoute: () => rootRouteImport,
} as any)
const ConnectTokenRoute = ConnectTokenRouteImport.update({
  id: '/connect/$token',
  path: '/connect/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const BillsHistoryRoute = BillsHistoryRouteImport.update({
  id: '/bills/history',
  path: '/bills/history',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms': typeof TermsRoute
  '/bills/history': typeof BillsHistoryRoute
  '/connect/$token': typeof ConnectTokenRoute
  '/household/create': typeof HouseholdCreateRoute
  '/household/invite': typeof HouseholdInviteRoute
  '/open-banking/callback': typeof OpenBankingCallbackRoute
  '/activity/': typeof ActivityIndexRoute
  '/bills/': typeof BillsIndexRoute
  '/budget/': typeof BudgetIndexRoute
  '/household/': typeof HouseholdIndexRoute
  '/import/': typeof ImportIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/insights/': typeof InsightsIndexRoute
  '/loans/': typeof LoansIndexRoute
  '/open-banking/': typeof OpenBankingIndexRoute
  '/plan/': typeof PlanIndexRoute
  '/savings/': typeof SavingsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/transactions/': typeof TransactionsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms': typeof TermsRoute
  '/bills/history': typeof BillsHistoryRoute
  '/connect/$token': typeof ConnectTokenRoute
  '/household/create': typeof HouseholdCreateRoute
  '/household/invite': typeof HouseholdInviteRoute
  '/open-banking/callback': typeof OpenBankingCallbackRoute
  '/activity': typeof ActivityIndexRoute
  '/bills': typeof BillsIndexRoute
  '/budget': typeof BudgetIndexRoute
  '/household': typeof HouseholdIndexRoute
  '/import': typeof ImportIndexRoute
  '/inbox': typeof InboxIndexRoute
  '/insights': typeof InsightsIndexRoute
  '/loans': typeof LoansIndexRoute
  '/open-banking': typeof OpenBankingIndexRoute
  '/plan': typeof PlanIndexRoute
  '/savings': typeof SavingsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/transactions': typeof TransactionsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/register': typeof RegisterRoute
  '/reset-password': typeof ResetPasswordRoute
  '/terms': typeof TermsRoute
  '/bills/history': typeof BillsHistoryRoute
  '/connect/$token': typeof ConnectTokenRoute
  '/household/create': typeof HouseholdCreateRoute
  '/household/invite': typeof HouseholdInviteRoute
  '/open-banking/callback': typeof OpenBankingCallbackRoute
  '/activity/': typeof ActivityIndexRoute
  '/bills/': typeof BillsIndexRoute
  '/budget/': typeof BudgetIndexRoute
  '/household/': typeof HouseholdIndexRoute
  '/import/': typeof ImportIndexRoute
  '/inbox/': typeof InboxIndexRoute
  '/insights/': typeof InsightsIndexRoute
  '/loans/': typeof LoansIndexRoute
  '/open-banking/': typeof OpenBankingIndexRoute
  '/plan/': typeof PlanIndexRoute
  '/savings/': typeof SavingsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/transactions/': typeof TransactionsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/register'
    | '/reset-password'
    | '/terms'
    | '/bills/history'
    | '/connect/$token'
    | '/household/create'
    | '/household/invite'
    | '/open-banking/callback'
    | '/activity/'
    | '/bills/'
    | '/budget/'
    | '/household/'
    | '/import/'
    | '/inbox/'
    | '/insights/'
    | '/loans/'
    | '/open-banking/'
    | '/plan/'
    | '/savings/'
    | '/settings/'
    | '/transactions/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/register'
    | '/reset-password'
    | '/terms'
    | '/bills/history'
    | '/connect/$token'
    | '/household/create'
    | '/household/invite'
    | '/open-banking/callback'
    | '/activity'
    | '/bills'
    | '/budget'
    | '/household'
    | '/import'
    | '/inbox'
    | '/insights'
    | '/loans'
    | '/open-banking'
    | '/plan'
    | '/savings'
    | '/settings'
    | '/transactions'
  id:
    | '__root__'
    | '/'
    | '/forgot-password'
    | '/login'
    | '/privacy'
    | '/register'
    | '/reset-password'
    | '/terms'
    | '/bills/history'
    | '/connect/$token'
    | '/household/create'
    | '/household/invite'
    | '/open-banking/callback'
    | '/activity/'
    | '/bills/'
    | '/budget/'
    | '/household/'
    | '/import/'
    | '/inbox/'
    | '/insights/'
    | '/loans/'
    | '/open-banking/'
    | '/plan/'
    | '/savings/'
    | '/settings/'
    | '/transactions/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  RegisterRoute: typeof RegisterRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  TermsRoute: typeof TermsRoute
  BillsHistoryRoute: typeof BillsHistoryRoute
  ConnectTokenRoute: typeof ConnectTokenRoute
  HouseholdCreateRoute: typeof HouseholdCreateRoute
  HouseholdInviteRoute: typeof HouseholdInviteRoute
  OpenBankingCallbackRoute: typeof OpenBankingCallbackRoute
  ActivityIndexRoute: typeof ActivityIndexRoute
  BillsIndexRoute: typeof BillsIndexRoute
  BudgetIndexRoute: typeof BudgetIndexRoute
  HouseholdIndexRoute: typeof HouseholdIndexRoute
  ImportIndexRoute: typeof ImportIndexRoute
  InboxIndexRoute: typeof InboxIndexRoute
  InsightsIndexRoute: typeof InsightsIndexRoute
  LoansIndexRoute: typeof LoansIndexRoute
  OpenBankingIndexRoute: typeof OpenBankingIndexRoute
  PlanIndexRoute: typeof PlanIndexRoute
  SavingsIndexRoute: typeof SavingsIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  TransactionsIndexRoute: typeof TransactionsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/transactions/': {
      id: '/transactions/'
      path: '/transactions'
      fullPath: '/transactions/'
      preLoaderRoute: typeof TransactionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/savings/': {
      id: '/savings/'
      path: '/savings'
      fullPath: '/savings/'
      preLoaderRoute: typeof SavingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plan/': {
      id: '/plan/'
      path: '/plan'
      fullPath: '/plan/'
      preLoaderRoute: typeof PlanIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/open-banking/': {
      id: '/open-banking/'
      path: '/open-banking'
      fullPath: '/open-banking/'
      preLoaderRoute: typeof OpenBankingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/loans/': {
      id: '/loans/'
      path: '/loans'
      fullPath: '/loans/'
      preLoaderRoute: typeof LoansIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/insights/': {
      id: '/insights/'
      path: '/insights'
      fullPath: '/insights/'
      preLoaderRoute: typeof InsightsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox/': {
      id: '/inbox/'
      path: '/inbox'
      fullPath: '/inbox/'
      preLoaderRoute: typeof InboxIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/import/': {
      id: '/import/'
      path: '/import'
      fullPath: '/import/'
      preLoaderRoute: typeof ImportIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/household/': {
      id: '/household/'
      path: '/household'
      fullPath: '/household/'
      preLoaderRoute: typeof HouseholdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/budget/': {
      id: '/budget/'
      path: '/budget'
      fullPath: '/budget/'
      preLoaderRoute: typeof BudgetIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bills/': {
      id: '/bills/'
      path: '/bills'
      fullPath: '/bills/'
      preLoaderRoute: typeof BillsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/activity/': {
      id: '/activity/'
      path: '/activity'
      fullPath: '/activity/'
      preLoaderRoute: typeof ActivityIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/open-banking/callback': {
      id: '/open-banking/callback'
      path: '/open-banking/callback'
      fullPath: '/open-banking/callback'
      preLoaderRoute: typeof OpenBankingCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/household/invite': {
      id: '/household/invite'
      path: '/household/invite'
      fullPath: '/household/invite'
      preLoaderRoute: typeof HouseholdInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/household/create': {
      id: '/household/create'
      path: '/household/create'
      fullPath: '/household/create'
      preLoaderRoute: typeof HouseholdCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect/$token': {
      id: '/connect/$token'
      path: '/connect/$token'
      fullPath: '/connect/$token'
      preLoaderRoute: typeof ConnectTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/bills/history': {
      id: '/bills/history'
      path: '/bills/history'
      fullPath: '/bills/history'
      preLoaderRoute: typeof BillsHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  RegisterRoute: RegisterRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  TermsRoute: TermsRoute,
  BillsHistoryRoute: BillsHistoryRoute,
  ConnectTokenRoute: ConnectTokenRoute,
  HouseholdCreateRoute: HouseholdCreateRoute,
  HouseholdInviteRoute: HouseholdInviteRoute,
  OpenBankingCallbackRoute: OpenBankingCallbackRoute,
  ActivityIndexRoute: ActivityIndexRoute,
  BillsIndexRoute: BillsIndexRoute,
  BudgetIndexRoute: BudgetIndexRoute,
  HouseholdIndexRoute: HouseholdIndexRoute,
  ImportIndexRoute: ImportIndexRoute,
  InboxIndexRoute: InboxIndexRoute,
  InsightsIndexRoute: InsightsIndexRoute,
  LoansIndexRoute: LoansIndexRoute,
  OpenBankingIndexRoute: OpenBankingIndexRoute,
  PlanIndexRoute: PlanIndexRoute,
  SavingsIndexRoute: SavingsIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  TransactionsIndexRoute: TransactionsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
